import { Picture, ProductCard } from 'ui/components';
import ProductListPrices from '../ProductList/ProductListPrices';
import ProductTag from '../ProductList/ProductTag';

type formatConsumerPrice = {
  price: string;
  maxPrice: string;
  percent: number | undefined;
};

type formatResellerPrice = {
  price: string;
  profit: string;
  maxPrice: string;
  discountPercentage: number;
};

type ProductListInfoProps = {
  discount: number;
  name: string;
  isAvailableCard: boolean;
  image: string;
  productCode: string;
  tags: string[];
  formatConsumerPrice: formatConsumerPrice;
  formatResellerPrice: formatResellerPrice;
  isResellerOnly: boolean;
};

export const ProductListInfo = ({
  discount,
  name,
  isAvailableCard,
  image,
  productCode,
  tags,
  formatConsumerPrice,
  formatResellerPrice,
  isResellerOnly,
}: ProductListInfoProps) => {
  return (
    <>
      {discount > 0 && (
        <ProductCard.TagDiscount
          tabIndex={0}
          aria-label={`descont de ${discount} por cento`}
          data-testid="discountPercentage"
        >
          -{discount}%
        </ProductCard.TagDiscount>
      )}
      <Picture
        alt={name}
        opacity={isAvailableCard ? '100' : '25'}
        ratio="4x3"
        tabIndex={0}
        sources={[
          {
            srcSet: `${image}`,
          },
        ]}
        src={image}
      />
      {!isAvailableCard && (
        <ProductCard.UnavailableStripe
          tabIndex={0}
          aria-label={'sem estoque'}
          data-departament-slider
        >
          Sem estoque
        </ProductCard.UnavailableStripe>
      )}

      <ProductCard.Code tabIndex={0} aria-label={`o SKU do produto é ${productCode}`}>
        {productCode}
      </ProductCard.Code>
      <ProductCard.Title tabIndex={0} aria-label={name} title={name}>
        {name}
      </ProductCard.Title>
      <ProductCard.Tags>
        {tags.map((tag: string) => (
          <ProductTag key={`${productCode}-${tag}`} tag={tag} />
        ))}
      </ProductCard.Tags>
      <ProductListPrices
        consumerPrice={formatConsumerPrice}
        resellerPrice={formatResellerPrice}
        isResellerOnly={isResellerOnly}
      />
    </>
  );
};

export default ProductListInfo;
